﻿export interface IAdminNotification {
    id: number;
    requestingCenterId: number;
    requestingCenterAlias: string;
    isEnabled: boolean;
    isRead: boolean;
    readDateTime: string;
    readByUserId: number;
    readByUser: string;
    description: string;
    notificationText: string;
    notificationTypeId: number;
    addedDateTime: string;
    additionalData: any
}
